// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PFixField } from './PFixField';
export class PFixByteField extends PFixField {
    constructor(fieldId, buffer) {
        super(fieldId, buffer);
        this.Value = 0;
    }
    ReadValue(buffer) {
        this.Value = buffer.ReadByte();
    }
    Write(buffer) {
        buffer.WriteShort(this.FieldId);
        buffer.WriteByte(this.Value);
    }
}
